import { Component, Input } from '@angular/core';
import { CommonModule, DecimalPipe, NgIf } from '@angular/common';
import { ToNumberPipe } from '../../../../../../../../pipes/to-number.pipe';
import {
  LocationOfDevicesUnrelatedToRoadOccupationStageFormValue
} from '../../forms/location-of-devices-unrelated-to-road-occupation-stage.form';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-stage-table',
  standalone: true,
  imports: [
    DecimalPipe,
    CommonModule,
    ToNumberPipe
  ],
  templateUrl: './location-of-devices-unrelated-to-road-stage-table.component.html'
})
export class LocationOfDevicesUnrelatedToRoadStageTableComponent {
  @Input()
  public stage: LocationOfDevicesUnrelatedToRoadOccupationStageFormValue | undefined;
}
